'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorDetail = exports.Detail = exports.MessageToFile = exports.MessageToTags = exports.MessageToContacts = exports.Message = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp, _dec, _class3, _desc2, _value2, _class4, _class5, _temp2, _dec2, _dec3, _class6, _desc3, _value3, _class7, _class8, _temp3, _dec4, _class9, _desc4, _value4, _class10, _class11, _temp4, _dec5, _class12, _desc5, _value5, _class13, _dec6, _class14;

var _components = require('components');

var _Snackbar = require('../../components/Snackbar/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _Snackbar3 = require('@material-ui/core/Snackbar');

var _Snackbar4 = _interopRequireDefault(_Snackbar3);

var _messages = require('redux/modules/messages');

var _contacts = require('redux/modules/contacts');

var _contact = require('redux/modules/contact');

var _themeEnabled = require('helpers/themeEnabled');

var _tags = require('redux/modules/tags');

var _status = require('redux/modules/status');

var _featureEnabled = require('helpers/featureEnabled');

var _LinkList = require('../../helpers/LinkList');

var _papaparse = require('papaparse');

var _papaparse2 = _interopRequireDefault(_papaparse);

var _Allow = require('../Allow/Allow');

var _Allow2 = _interopRequireDefault(_Allow);

var _Checkbox = require('@material-ui/core/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Tooltip = require('@material-ui/core/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Info = require('@material-ui/icons/Info');

var _Info2 = _interopRequireDefault(_Info);

var _index = require('../../../node_modules/@material-ui/icons/index');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _MessageScheduler = require('./MessageScheduler');

var _MessageScheduler2 = _interopRequireDefault(_MessageScheduler);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _reduxConnect = require('redux-connect');

var _coreDecorators = require('core-decorators');

var _reactRedux = require('react-redux');

var _shortLink = require('redux/modules/shortLink');

var _unread = require('redux/modules/unread');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reachHistory = require('../../helpers/reachHistory');

var _reduxForm = require('redux-form');

var _reports = require('redux/modules/reports');

var _sessionPermissions = require('../../helpers/sessionPermissions');

var _Message4 = require('./Message.scss');

var _Message5 = _interopRequireDefault(_Message4);

var _useBasename = require('../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

var _string = require('helpers/string');

var _lodash = require('lodash');

var _getTimeFromMinutes = require('../../helpers/getTimeFromMinutes');

var _getTimeFromMinutes2 = _interopRequireDefault(_getTimeFromMinutes);

var _interactivePromotion = require('redux/modules/interactivePromotion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var md = {
  search: require('react-icons/lib/md/search'),
  person: require('react-icons/lib/md/person'),
  arrowBack: require('react-icons/lib/md/arrow-back'),
  personAdd: require('react-icons/lib/md/add'),
  close: require('react-icons/lib/md/clear'),
  tag: require('react-icons/lib/md/label'),
  attach: require('react-icons/lib/md/attach-file'),
  calendar: require('react-icons/lib/md/today'),
  message: require('react-icons/lib/md/email'),
  error: require('react-icons/lib/md/error-outline')
};

var MessageForm = (0, _reduxForm.reduxForm)({
  form: 'message'
})(_components.MessageFormContainer);

var Message = exports.Message = (_class = (_temp = _class2 = function (_List) {
  (0, _inherits3.default)(Message, _List);

  function Message(props) {
    (0, _classCallCheck3.default)(this, Message);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Message.__proto__ || (0, _getPrototypeOf2.default)(Message)).call(this, props));

    _this.handleSelectionActivate = function () {
      _this.setState((0, _extends3.default)({}, _this.state, {
        selecting: true
      }));
    };

    _this.turnTesting = function () {
      _this.setState(function (prevState) {
        return {
          testing: !prevState.testing
        };
      });
    };

    _this.handleCheckTrace = function () {};

    _this.handleSelectionDeactivate = function () {
      _this.setState((0, _extends3.default)({}, _this.state, {
        selecting: false
      }));
    };

    _this.handleUnselectAll = function () {
      console.error('not implemented');
    };

    _this.handleScheduling = function () {
      _this.setState((0, _extends3.default)({}, _this.state, {
        scheduling: !_this.state.scheduling
      }));
    };

    _this.handleScheduled = function (scheduledFor) {
      var text = '';
      var startDate = (0, _moment2.default)(scheduledFor.startDate).format('DD/MM');
      var finishDate = (0, _moment2.default)(scheduledFor.finishDate).format('DD/MM');
      if (scheduledFor.finish) {
        text += (0, _translations2.default)('FROM') + ' ';
      }
      text += startDate + ' ' + scheduledFor.hour + ' ';
      if (scheduledFor.finish) {
        text += (0, _translations2.default)('TO') + ' ' + finishDate + ' ';
      }
      if (scheduledFor.recurring) {
        text += (0, _translations2.default)('EVERY') + ' ';
      }
      if (scheduledFor.recurring) {
        switch (scheduledFor.frequency) {
          case 'WEEKLY':
            if (scheduledFor.day_monday) {
              text += (0, _translations2.default)('MONDAY') + ' ';
            }
            if (scheduledFor.day_tuesday) {
              text += (0, _translations2.default)('TUESDAY') + ' ';
            }
            if (scheduledFor.day_wednesday) {
              text += (0, _translations2.default)('WEDNESDAY') + ' ';
            }
            if (scheduledFor.day_thursday) {
              text += (0, _translations2.default)('THURSDAY') + ' ';
            }
            if (scheduledFor.day_friday) {
              text += (0, _translations2.default)('FRIDAY') + ' ';
            }
            if (scheduledFor.day_saturday) {
              text += (0, _translations2.default)('SATURDAY') + ' ';
            }
            if (scheduledFor.day_sunday) {
              text += (0, _translations2.default)('SUNDAY') + ' ';
            }
            break;
          case 'MONTHLY':
            text += (0, _translations2.default)('MONTH');
            break;
          case 'YEARLY':
            text += (0, _translations2.default)('YEAR');
            break;
          default:
            text += (0, _translations2.default)('DAY');
        }
      }
      _this.setState((0, _extends3.default)({}, _this.state, {
        scheduledFor: scheduledFor,
        scheduledText: text,
        scheduling: false
      }));
    };

    _this.state = (0, _extends3.default)({}, _this.state, {
      selecting: false,
      scheduling: false,
      scheduledFor: {},
      scheduledText: '',
      sending: false,
      data: {},
      selected: null,
      accountStatus: null,
      testNumbers: [],
      testTagNumbers: [],
      testing: false,
      snackMessage: '',
      snackStatus: 'succeed',
      showSnack: false
    });
    _this.tags = [];
    _this.isStaff = _this.props.location.pathname.startsWith('/staff/');
    _this.url = 'messages';
    if (_this.isStaff) {
      _this.url = 'staff/messages';
    }
    return _this;
  }

  (0, _createClass3.default)(Message, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.getAccountStatus().then(function (accountStatus) {
        _this2.setState({ accountStatus: accountStatus });
      });
    }
  }, {
    key: 'getExtraParams',
    value: function getExtraParams() {
      return {
        main_identifier: 'msisdn',
        filter_no_contacts: 0
      };
    }
  }, {
    key: 'handleGetNumbers',
    value: function handleGetNumbers(tags) {
      var newTags = tags.map(function (t) {
        return t.value;
      });
      this.setState({
        testNumbers: newTags,
        testTagNumbers: tags,
        validateChangeTestMessage: false,
        testFileStats: null
      });
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      if (!this.isStaff) {
        var permissionTabs = [];

        var tabIndivudal = {
          'href': {
            pathname: '/messages/add',
            state: { modal: true, returnTo: '/messages/' }
          },
          'title': (0, _translations2.default)('SEND TO CONTACT'),
          'is_index': true
        };
        var tabTags = {
          'href': {
            pathname: '/messages/addTags',
            state: { modal: true, returnTo: '/messages/' }
          },
          'title': (0, _translations2.default)('SEND TO TAGS')
        };

        var tabFile = {
          'href': {
            pathname: '/messages/addFile',
            state: { modal: true, returnTo: '/messages/' }
          },
          'title': (0, _translations2.default)('SEND TO FILE')
        };

        var link_uid = this.props.params.short_link_uid;
        var tabFileLink = {
          'href': {
            pathname: '/short_link/' + link_uid + '/addFile',
            state: { modal: true, returnTo: '/short_link/' + link_uid }
          },
          'title': (0, _translations2.default)('SEND TO FILE')
        };

        var keyword = this.props.params.keyword;
        var tabFilePromotion = {
          'href': {
            pathname: '/interactive/promotion/' + keyword + '/addFile',
            state: { modal: true, returnTo: '/messages/' }
          },
          'title': (0, _translations2.default)('SEND TO FILE')
        };

        if (link_uid) {
          if ((0, _sessionPermissions.sessionPermissions)('short:link:list')) {
            permissionTabs.push(tabFileLink);
          }
        } else if (keyword) {
          if ((0, _sessionPermissions.sessionPermissions)('interactive:promotions:list')) {
            permissionTabs.push(tabFilePromotion);
          }
        } else {
          if ((0, _sessionPermissions.sessionPermissions)('channels:sms:send:single')) {
            permissionTabs.push(tabIndivudal);
          }

          if ((0, _sessionPermissions.sessionPermissions)('channels:sms:send:tag')) {
            permissionTabs.push(tabTags);
          }

          if ((0, _sessionPermissions.sessionPermissions)('channels:sms:send:file')) {
            permissionTabs.push(tabFile);
          }
        }

        return _react2.default.createElement(_components.Tabs, { options: permissionTabs });
      }
      return _react2.default.createElement(_components.Tabs, { options: [{
          'href': {
            pathname: '/staff/messages/addTags',
            state: { modal: true, returnTo: '/staff/messages/' }
          },
          'title': (0, _translations2.default)('SEND TO TAGS'),
          'is_index': true
        }, {
          'href': {
            pathname: '/staff/messages/add',
            state: { modal: true, returnTo: '/staff/messages/' }
          },
          'title': (0, _translations2.default)('SEND TO CONTACT')
        }] });
    }
  }, {
    key: 'renderSelector',
    value: function renderSelector() {
      return _react2.default.createElement(
        'h1',
        null,
        'NOT IMPLEMENTED'
      );
    }
  }, {
    key: 'renderSelected',
    value: function renderSelected() {
      return _react2.default.createElement(
        'h1',
        null,
        'NOT IMPLEMENTED'
      );
    }
  }, {
    key: 'renderDate',
    value: function renderDate() {
      return _react2.default.createElement(
        'h1',
        null,
        'NOT IMPLEMENTED'
      );
    }
  }, {
    key: 'showSnackBar',
    value: function showSnackBar(message, status) {
      this.setState({
        snackMessage: message,
        snackStatus: status,
        showSnack: true
      });
      return true;
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      return;
    }
  }, {
    key: 'loadScheduler',
    value: function loadScheduler(values) {
      var _this3 = this;

      var events = [];
      if (this.props.location) {
        if (this.props.location.state) {
          events = this.props.location.state.data ? this.props.location.state.data.events : [];
        }
      }
      var data = {
        message: values.message,
        events: events
      };

      if (this.props.target === 'Tags') {
        var tagsList = this.props.selected.map(function (s) {
          return (0, _defineProperty3.default)({}, s, _this3.props.list[s]);
        });

        if (tagsList) {
          data.tagsList = tagsList;
        }
      } else {
        var contactsList = this.props.selected.map(function (s) {
          return (0, _defineProperty3.default)({}, s, _this3.props.list[s].msisdn);
        });

        if (contactsList) {
          data.contacts = contactsList;
        }
      }

      this.props.push({
        pathname: '/messages/scheduler',
        state: {
          modal: true,
          loading: true,
          modalSize: { height: '600px', width: '900px' },
          returnTo: '/messages/',
          data: data
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var messageValue = '';
      var shortName = '';
      var accountStatus = this.state.accountStatus;
      var shortnamePrefixLength = accountStatus && accountStatus.csm && accountStatus.csm.api_use_short_name ? accountStatus.sms_short_name.length + 2 : 0;
      var maxLength = 612 - shortnamePrefixLength;
      if (this.props.location) {
        if (this.props.location.state) {
          messageValue = this.props.location.state.data ? this.props.location.state.data : '';
        }
      }
      if (accountStatus && accountStatus.csm && accountStatus.csm.api_use_short_name === true) {
        shortName += accountStatus.sms_short_name + ': ';
      }

      if (this.state.selecting) {
        return _react2.default.createElement(
          'div',
          { className: _Message5.default.message },
          _react2.default.createElement(_components.MobileBar, { title: (0, _translations2.default)('SELECT CONTACTS'), extraAction: this.handleSelectionDeactivate, extraIcon: md.close }),
          this.renderSelector(),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.selectorActions },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: _Message5.default.selectorAction, onClick: this.handleUnselectAll },
              (0, _translations2.default)('CLEAR SELECTION')
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: _Message5.default.selectorAction, onClick: this.handleSelectionDeactivate },
              (0, _translations2.default)('SELECT')
            )
          )
        );
      }

      var selectedClassNames = _Message5.default.selected + ' ' + (this.props.mobileMode ? ' ' + _Message5.default.mobile : '');
      if (this.state.scheduling) {
        return _react2.default.createElement(_MessageScheduler2.default, { onSubmit: this.handleScheduled, toReturn: this.handleScheduling });
      }

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.message },
        _react2.default.createElement(_reactHelmet2.default, { title: "Nuevo mensaje" }),
        this.renderTabs(),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.main },
          _react2.default.createElement(_Snackbar2.default, {
            messageText: this.state.snackMessage,
            variant: this.state.snackStatus,
            isOpen: this.state.showSnack,
            autoHideDuration: 2600,
            handleClose: function handleClose() {
              return _this4.setState({ showSnack: false });
            }
          }),
          this.props.mobileMode ? null : this.renderSelector(),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.right },
            !this.props.mobileMode ? _react2.default.createElement(
              'label',
              { className: _Message5.default.label },
              (0, _translations2.default)('SEND TO'),
              ':'
            ) : null,
            _react2.default.createElement(
              'div',
              { className: selectedClassNames },
              this.renderSelected()
            ),
            this.props.mobileMode ? _react2.default.createElement(md.personAdd, { onClick: this.handleSelectionActivate, size: 30, className: _Message5.default.select, key: '1' }) : null,
            _react2.default.createElement(_components.MessageFormContainer, { shortName: shortName, onSubmit: this.loadScheduler, initialValues: messageValue || '', postMessage: this.sendMessage, key: '2', selected: this.props.selected.length, loading: this.state.sending, isEdit: this.props.location ? this.props.location.state ? this.props.location.state.isEdit : false : false, maxLength: maxLength }),
            _react2.default.createElement(_components.RemoteSubmitButton, null)
          )
        )
      );
    }
  }]);
  return Message;
}(_components.List), _class2.propTypes = {
  target: _propTypes2.default.string.isRequired,
  mobileMode: _propTypes2.default.bool.isRequired
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'handleGetNumbers', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleGetNumbers'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadScheduler', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadScheduler'), _class.prototype)), _class);
var MessageToContacts = exports.MessageToContacts = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    mobileMode: state.mobile.mobileMode,
    message: state.messagesSent,
    selected: state.contacts.selected,
    list: state.contacts.list
  };
}, {
  sendMessage: _messages.messageSendMultiple,
  push: _reachHistory.push,
  get: _contacts.getContacts,
  getShortLinkDetail: _shortLink.getShortLinkDetail,
  getLanding: _shortLink.getLanding,
  select: _contacts.contactSelect,
  unselect: _contacts.contactUnselect,
  contactsUnselectAll: _contacts.contactsUnselectAll,
  refresh: _contacts.contactsRefresh,
  getAccountStatus: _status.getAccountStatus,
  createContact: _contact.createContact
}), _dec(_class3 = (_class4 = (_temp2 = _class5 = function (_Message) {
  (0, _inherits3.default)(MessageToContacts, _Message);

  function MessageToContacts() {
    (0, _classCallCheck3.default)(this, MessageToContacts);
    return (0, _possibleConstructorReturn3.default)(this, (MessageToContacts.__proto__ || (0, _getPrototypeOf2.default)(MessageToContacts)).apply(this, arguments));
  }

  (0, _createClass3.default)(MessageToContacts, [{
    key: 'sendMessage',
    value: function sendMessage(resetForm, form) {
      var _this6 = this;

      var message = form.message;
      var list = this.props.selected.map(function (s) {
        return _this6.props.list[s].msisdn;
      });
      var daysOfWeek = [this.state.scheduledFor.day_monday, this.state.scheduledFor.day_tuesday, this.state.scheduledFor.day_wednesday, this.state.scheduledFor.day_thursday, this.state.scheduledFor.day_friday, this.state.scheduledFor.day_saturday, this.state.scheduledFor.day_sunday].map(function (pi, i) {
        return { pi: pi, i: i };
      }).filter(function (pit) {
        return pit.pi;
      }).map(function (pit) {
        return pit.i + 1;
      });

      var scheduledFor = this.state.scheduledFor.startDate || this.state.scheduledFor.finishDate ? {
        country_code: null,
        end_date: this.state.scheduledFor.recurring && this.state.scheduledFor.finish ? this.state.scheduledFor.finishDate : null,
        event_name: message,
        repeat_interval: this.state.scheduledFor.recurring ? this.state.scheduledFor.frequency : 'ONCE',
        days_of_week: daysOfWeek,
        fields: null,
        start_date: this.state.scheduledFor.startDate,
        execution_time: this.state.scheduledFor.hour,
        scheduled: true,
        type: 'SINGLE'
      } : null;

      this.setState((0, _extends3.default)({}, this.state, {
        sending: true
      }));

      return this.props.sendMessage(list, message, scheduledFor).then(function () {
        // this.props.messagesRefresh()
        _this6.setState((0, _extends3.default)({}, _this6.state, {
          sending: false
        }));
        _this6.props.push({
          pathname: '/success',
          state: {
            goTo: '/' + _this6.url + '/',
            goToModal: false,
            message: scheduledFor && scheduledFor.scheduled ? (0, _translations2.default)('MESSAGE SCHEDULE SUCCESS') : (0, _translations2.default)('MESSAGE SEND SUCCESS'),
            modal: true,
            returnTo: '/messages/'
          }
        });
        resetForm();
      }).catch(function (e) {
        console.error('Could not send message', e);
        _this6.setState((0, _extends3.default)({}, _this6.state, {
          sending: false
        }));
        _this6.props.push({
          pathname: '/fail',
          state: {
            goTo: '/' + _this6.url + '/',
            goToModal: false,
            message: e.message,
            modal: !_this6.props.mobileMode,
            returnTo: '/messages/'
          }
        });
      });
    }
  }, {
    key: 'handleCreateContact',
    value: function handleCreateContact() {
      var _this7 = this;

      var form = {};
      var variables = {};
      var country_code = '';
      var msisdn = this.state.search;
      this.props.createContact(form, variables, country_code, msisdn).then(function (contact) {
        contact.active = true;
        console.debug('Contact created', contact);
        _this7.showSnackBar((0, _translations2.default)('CONTACT ADD SUCCESS'), 'success');
        _this7.props.get({ search: msisdn }).then(function () {
          _this7.props.select(0);
        }).catch(function (e) {
          _this7.showSnackBar((0, _translations2.default)('CONTACT SELECT ERROR'), 'warning');
          console.debug('Error on get contacts', e);
        });
      }).catch(function (response) {
        _this7.showSnackBar((0, _translations2.default)('CONTACT ADD ERROR') + ' "' + response.message + '"', 'error');
        console.debug('Error on create contact', response);
      });
    }
  }, {
    key: 'deleteFromSelected',
    value: function deleteFromSelected(i) {
      this.props.unselect(i);
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      return _react2.default.createElement(
        'div',
        { className: _Message5.default.search },
        _react2.default.createElement('input', {
          type: 'text',
          placeholder: (0, _translations2.default)('CONTACT SEARCH PLACEHOLDER'),
          value: this.state.search || '',
          ref: 'search',
          onChange: this.handleSearch,
          onKeyPress: this.handleSearch,
          className: _Message5.default.searchInput
        }),
        _react2.default.createElement(md.search, { className: _Message5.default.searchIcon }),
        _react2.default.createElement(
          'span',
          { className: _Message5.default.clear, onClick: this.handleClear, style: this.state.search ? {} : { display: 'none' } },
          '\xD7'
        )
      );
    }
  }, {
    key: 'renderSelector',
    value: function renderSelector() {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.selector },
        this.renderSearchBar(),
        _react2.default.createElement(
          _components.Infinite,
          {
            refresh: this.refreshRows,
            next: this.loadMoreRows,
            hasMore: this.state.hasMoreRows
          },
          this.props.list.length === 0 && this.state.search !== '' ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: _Message5.default.button + ' ' + _Message5.default.addContactButton,
                onClick: this.handleCreateContact
              },
              (0, _translations2.default)('CREATE NEW CONTACT')
            )
          ) : this.props.list.map(function (item, index) {
            return _react2.default.createElement(_components.VirtualListItemSlim, {
              key: item.id,
              index: index,
              text: function () {
                var name = item.profile.first_name ? item.profile.first_name.value : '';
                var lastname = item.profile.last_name ? item.profile.last_name.value : '';
                if (name || lastname) {
                  return name + ' ' + lastname;
                }
                return item.msisdn;
              }(),
              icon: _react2.default.createElement(md.person, { size: 20, className: _Message5.default.listicon }),
              mobileMode: _this8.props.mobileMode,
              active: item.active,
              setActive: _this8.setActive.bind(_this8),
              modal: true
            });
          })
        )
      );
    }
  }, {
    key: 'renderSelected',
    value: function renderSelected() {
      var _this9 = this;

      var contacts = null;
      if (this.props.location) {
        if (this.props.location.state) {
          contacts = this.props.location.state.data ? this.props.location.state.data.contacts : null;
        }
      }

      var selectedContacts = this.props.selected;

      if (contacts) {
        contacts.forEach(function (contact) {
          _this9.props.list.forEach(function (item, key) {
            if ((0, _values2.default)(contact) == item.msisdn) {
              selectedContacts.push(key);
            }
          });
        });
      }
      _contacts.getContacts;
      if (selectedContacts) {
        var filterContacts = function filterContacts(contact) {
          return contact.filter(function (v, i) {
            return contact.indexOf(v) === i;
          });
        };
        selectedContacts = filterContacts(selectedContacts);
      }

      return selectedContacts.map(function (s) {
        var name = _this9.props.list[s].profile.first_name ? _this9.props.list[s].profile.first_name.value : '';
        var lastname = _this9.props.list[s].profile.last_name ? ' ' + _this9.props.list[s].profile.last_name.value : '';
        var fullName = '' + name + lastname;
        var displayName = fullName !== '' ? fullName : _this9.props.list[s].msisdn;
        return _react2.default.createElement(
          'div',
          { key: s, className: _Message5.default.contact },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(md.person, { size: 14, className: _Message5.default.icon }),
            displayName,
            _react2.default.createElement(md.close, { onClick: function onClick() {
                return _this9.deleteFromSelected(s);
              }, size: 13, className: _Message5.default.icon })
          )
        );
      });
    }
  }, {
    key: 'renderDate',
    value: function renderDate() {
      return _react2.default.createElement(
        'div',
        { className: _Message5.default.scheduledFor },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.date },
          this.state.scheduledText ? this.state.scheduledText : (0, _translations2.default)('NOW')
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.label },
          (0, _translations2.default)('SEND WHEN'),
          ':'
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.button },
          _react2.default.createElement(md.calendar, { size: 30, onClick: this.handleScheduling })
        )
      );
    }
  }]);
  return MessageToContacts;
}(Message), _class5.propTypes = {
  selected: _propTypes2.default.array.isRequired
}, _class5.defaultProps = {
  target: 'Contacts'
}, _temp2), (_applyDecoratedDescriptor(_class4.prototype, 'sendMessage', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, 'sendMessage'), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, 'handleCreateContact', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, 'handleCreateContact'), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, 'deleteFromSelected', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, 'deleteFromSelected'), _class4.prototype)), _class4)) || _class3);
var MessageToTags = exports.MessageToTags = (_dec2 = (0, _reduxConnect.asyncConnect)([{
  key: 'tags',
  promise: function promise(_ref3) {
    var _ref3$store = _ref3.store,
        dispatch = _ref3$store.dispatch,
        getState = _ref3$store.getState;

    return dispatch((0, _tags.getTagsRefactor)());
  }
}]), _dec3 = (0, _reactRedux.connect)(function (state) {
  return {
    mobileMode: state.mobile.mobileMode,
    message: state.messagesSent,
    selected: state.tags.selected,
    list: state.tags.list
  };
}, {
  sendMessage: _messages.messageSendTags,
  push: _reachHistory.push,
  get: _tags.getTagsRefactor,
  select: _tags.tagsSelect,
  unselect: _tags.tagsUnselect,
  tagsUnselectAll: _tags.tagsUnselectAll,
  refresh: _tags.tagsRefresh,
  messagesRefresh: _messages.sentMessagesRefresh,
  getAccountStatus: _status.getAccountStatus
}), _dec2(_class6 = _dec3(_class6 = (_class7 = (_temp3 = _class8 = function (_Message2) {
  (0, _inherits3.default)(MessageToTags, _Message2);

  function MessageToTags(props) {
    (0, _classCallCheck3.default)(this, MessageToTags);

    var _this10 = (0, _possibleConstructorReturn3.default)(this, (MessageToTags.__proto__ || (0, _getPrototypeOf2.default)(MessageToTags)).call(this, props));

    _this10.handleUnselectAll = function () {
      _this10.props.tagsUnselectAll();
    };

    _this10.state = (0, _extends3.default)({}, _this10.state, {
      renderList: false,
      list: _this10.props.tags
    });
    return _this10;
  }

  (0, _createClass3.default)(MessageToTags, [{
    key: 'getExtraParams',
    value: function getExtraParams() {
      return {
        channel_filter: 'SMS'
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.tagsUnselectAll();
    }
  }, {
    key: 'deleteFromSelected',
    value: function deleteFromSelected(i) {
      this.props.unselect(i);
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(resetForm, form) {
      var _this11 = this;

      var message = form.message;
      var list = this.props.selected.map(function (s) {
        return _this11.props.list[s].name;
      });
      var daysOfWeek = [this.state.scheduledFor.day_monday, this.state.scheduledFor.day_tuesday, this.state.scheduledFor.day_wednesday, this.state.scheduledFor.day_thursday, this.state.scheduledFor.day_friday, this.state.scheduledFor.day_saturday, this.state.scheduledFor.day_sunday].map(function (pi, i) {
        return { pi: pi, i: i };
      }).filter(function (pit) {
        return pit.pi;
      }).map(function (pit) {
        return pit.i + 1;
      });

      var scheduledFor = this.state.scheduledFor.startDate || this.state.scheduledFor.finishDate ? {
        country_code: null,
        end_date: this.state.scheduledFor.recurring && this.state.scheduledFor.finish ? this.state.scheduledFor.finishDate : null,
        event_name: message,
        repeat_interval: this.state.scheduledFor.recurring ? this.state.scheduledFor.frequency : 'ONCE',
        days_of_week: daysOfWeek,
        fields: null,
        start_date: this.state.scheduledFor.startDate,
        execution_time: this.state.scheduledFor.hour,
        scheduled: true,
        type: 'TAG',
        tags: list
      } : null;

      this.setState((0, _extends3.default)({}, this.state, {
        sending: true
      }));

      return this.props.sendMessage(list, message, scheduledFor).then(function () {
        // this.props.messagesRefresh()
        _this11.setState((0, _extends3.default)({}, _this11.state, {
          sending: false
        }));
        _this11.props.push({
          pathname: '/success',
          state: {
            goTo: '' + _this11.url,
            goToModal: false,
            message: scheduledFor && scheduledFor.scheduled ? (0, _translations2.default)('MESSAGE SCHEDULE SUCCESS') : (0, _translations2.default)('MESSAGE SEND SUCCESS'),
            modal: true,
            returnTo: '' + _this11.url
          }
        });
        resetForm();
      }).catch(function (e) {
        console.error('Could not send message', e);
        _this11.setState((0, _extends3.default)({}, _this11.state, {
          sending: false
        }));
        _this11.props.push({
          pathname: '/fail',
          state: {
            goTo: '' + _this11.url,
            goToModal: false,
            message: e.message,
            modal: true,
            returnTo: '' + _this11.url
          }
        });
      });
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var _this12 = this;

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.search },
        _react2.default.createElement('input', {
          type: 'text',
          placeholder: (0, _translations2.default)('TAG SEARCH PLACEHOLDER'),
          ref: 'search',
          onChange: function onChange(e) {
            return _this12.setState({ search: e.target.value });
          },
          value: this.state.search,
          className: _Message5.default.searchInput
        }),
        _react2.default.createElement(md.search, { className: _Message5.default.searchIcon })
      );
    }
  }, {
    key: 'renderTagList',
    value: function renderTagList() {
      var _this13 = this;

      var list = this.state.list;

      var searchField = this.refs.search ? (this.refs.search.value || '').trim().toUpperCase() : '';
      var save_list = null;
      if (this.props.location) {
        if (this.props.location.state.data) {
          if (this.props.location.state.data.tagsList) {
            save_list = this.props.location.state.data.tagsList;
          }
        }
      }

      var renderList = this.state.renderList;

      if (renderList === false && save_list === null) {}

      return list.map(function (item, index) {
        return { item: item, index: index };
      }).filter(function (_ref4) {
        var item = _ref4.item;
        return item.name && item.name.toUpperCase().indexOf(searchField) > -1;
      }).map(function (_ref5) {
        var item = _ref5.item,
            index = _ref5.index;

        var active = false;
        if (save_list) {
          save_list.forEach(function (element) {
            var thisItem = (0, _values2.default)((0, _values2.default)(element));
            if (thisItem[0].name === item.name) {
              active = true;
            }
          });
        }

        return _react2.default.createElement(_components.VirtualListItemSlim, {
          key: index,
          index: index,
          text: item.name,
          mobileMode: _this13.props.mobileMode,
          icon: _react2.default.createElement(md.tag, { size: 20, className: _Message5.default.listicon }),
          active: active,
          setActive: _this13.setActive.bind(_this13),
          count: item.count,
          modal: true
        });
      });
    }
  }, {
    key: 'renderSelector',
    value: function renderSelector() {
      return _react2.default.createElement(
        'div',
        { className: _Message5.default.selector },
        this.renderSearchBar(),
        this.renderTagList()
      );
    }
  }, {
    key: 'renderSelected',
    value: function renderSelected() {
      var _this14 = this;

      var tagsSelected = void 0;
      if (this.props.location) {
        tagsSelected = this.props.location.state.data ? this.props.location.state.data.tagsList : null;
      }

      if (tagsSelected) {
        var list = [];
        list = this.props.list;
        tagsSelected.forEach(function (tag) {
          list.map(function (val, index) {
            if (val.name == tag[(0, _keys2.default)(tag)].name) {
              if (_this14.props.selected.indexOf(index) == -1) {
                _this14.props.selected.push(index);
                _this14.setState((0, _extends3.default)({}, _this14.state, { isRender: true }));
              }
            }
          });
        });

        //limpiamos
        var _cleanArray = [];
        this.props.selected.forEach(function (valor, index) {
          if (_cleanArray.indexOf(valor) == -1) {
            _cleanArray.push(valor);
          } else {
            _this14.props.selected.splice(index, 1);
            _this14.props.selected.splice(_this14.props.selected.indexOf(valor), 1);
          }
        });
        return this.props.selected.map(function (s) {
          return _react2.default.createElement(
            'div',
            { key: s, className: _Message5.default.contact },
            _react2.default.createElement(md.tag, { size: 14, className: _Message5.default.icon }),
            _this14.props.list[s].name
          );
        });
      }
      //limpiamos
      var cleanArray = [];
      this.props.selected.forEach(function (valor, index) {
        if (cleanArray.indexOf(valor) == -1) {
          cleanArray.push(valor);
        } else {
          _this14.props.selected.splice(index, 1);
          _this14.props.selected.splice(_this14.props.selected.indexOf(valor), 1);
        }
      });
      return this.props.selected.map(function (s) {
        return _react2.default.createElement(
          'div',
          { key: s, className: _Message5.default.contact },
          _react2.default.createElement(md.tag, { size: 14, className: _Message5.default.icon }),
          _this14.props.list[s].name,
          _react2.default.createElement(md.close, { onClick: function onClick() {
              return _this14.deleteFromSelected(s);
            }, size: 13, className: _Message5.default.icon })
        );
      });
    }
  }, {
    key: 'renderDate',
    value: function renderDate() {
      return _react2.default.createElement(
        'div',
        { className: _Message5.default.scheduledFor },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.label },
          (0, _translations2.default)('SEND WHEN'),
          ':'
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.date },
          this.state.scheduledText ? this.state.scheduledText : (0, _translations2.default)('NOW')
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.button },
          _react2.default.createElement(md.calendar, { size: 30, onClick: this.handleScheduling })
        )
      );
    }
  }]);
  return MessageToTags;
}(Message), _class8.defaultProps = {
  target: 'Tags'
}, _temp3), (_applyDecoratedDescriptor(_class7.prototype, 'deleteFromSelected', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class7.prototype, 'deleteFromSelected'), _class7.prototype), _applyDecoratedDescriptor(_class7.prototype, 'sendMessage', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class7.prototype, 'sendMessage'), _class7.prototype)), _class7)) || _class6) || _class6);
var MessageToFile = exports.MessageToFile = (_dec4 = (0, _reactRedux.connect)(function (state) {
  return {
    mobileMode: state.mobile.mobileMode,
    message: state.messagesSent,
    user: state.auth.data.user,
    account: state.account.data,
    selected: state.contacts.selected,
    list: state.contacts,
    balance: state.reports.data

  };
}, {
  messageSendFile: _messages.messageSendFile,
  push: _reachHistory.push,
  messagesRefresh: _messages.sentMessagesRefresh,
  messageUpdateFileStats: _messages.messageUpdateFileStats,
  messageConfirmSendFile: _messages.messageConfirmSendFile,
  getContacts: _contacts.getContacts,
  getShortLinkDetail: _shortLink.getShortLinkDetail,
  getLanding: _shortLink.getLanding,
  select: _contacts.contactSelect,
  unselect: _contacts.contactUnselect,
  getAccountStatus: _status.getAccountStatus,
  createTagsRefactor: _tags.createTagsRefactor,
  incrementTagFileCount: _tags.incrementTagFileCount,
  getPromotionByKeyword: _interactivePromotion.getPromotionByKeyword
}), _dec4(_class9 = (_class10 = (_temp4 = _class11 = function (_Message3) {
  (0, _inherits3.default)(MessageToFile, _Message3);

  function MessageToFile(props) {
    (0, _classCallCheck3.default)(this, MessageToFile);

    var _this15 = (0, _possibleConstructorReturn3.default)(this, (MessageToFile.__proto__ || (0, _getPrototypeOf2.default)(MessageToFile)).call(this, props));

    _this15.validatePhone = function (phone) {
      var namesPhones = ["TELEFONO", "MSISDN", "TEL", "TEL.", "TELEFONOS", "PHONE", "PHONES"];
      var findIt = namesPhones.filter(function (name) {
        return name === phone;
      });
      return findIt.length == 0 ? true : false;
    };

    _this15.validateMessage = function (message) {
      var namesMessage = ["MENSAJE", "MENSAJES", "MESSAGE", "MESSAGES"];
      var findIt = namesMessage.filter(function (name) {
        return name === message;
      });
      var notMessage = findIt.length == 0 ? true : false;
      return notMessage;
    };

    _this15.checkLandingTagsInFileInformation = function (landingPageTags, fileInformationTags) {
      var missingTags = {};

      if (landingPageTags) {
        for (var tag in landingPageTags) {
          if (!fileInformationTags.hasOwnProperty(tag)) {
            missingTags[tag] = landingPageTags[tag];
          }
        }
      }

      return missingTags;
    };

    _this15.isIn = function (value) {
      var foundIt = _this15.state.selected.find(function (contact) {
        return contact.id == value.id;
      });
      return foundIt ? true : false;
    };

    _this15.styles = require('./Message.scss');
    _this15.state = (0, _extends3.default)({}, _this15.state, {
      messageInFile: false,
      selecting: false,
      files: [],
      messagePreview: {
        message: ''
      },
      fileInfo: {
        counter: 0,
        messagesPreview: [],
        contactsPreview: [],
        variablesPreview: [],
        dataFile: null,
        message: null,
        contacts: [],
        events: []
      },
      fileUploadResult: null,
      testFileUploadResult: null,
      fileStats: null,
      testFileStats: null,
      testTrackableUrls: false,
      validateChangeTestMessage: false,
      validateChangeMessage: false,
      renderMessage: 0,
      monitoringContacts: [],
      selectedMonitoringContacts: [],
      isChecked: [],
      selected: [],
      accountStatus: null,
      trackableUrls: false,
      tags: [],
      exceedsFileLimit: false,
      keywordValidationFailed: false
    });
    _this15.formData = null;
    _this15.textAreaRef = _react2.default.createRef();
    return _this15;
  }

  (0, _createClass3.default)(MessageToFile, [{
    key: 'short_link_detail',
    value: function short_link_detail(link_uid, landing_flag) {
      var _this16 = this;

      this.props.getShortLinkDetail(link_uid).then(function (data) {
        _this16.setState({
          short_link: data.short_url,
          link_name: data.name,
          reference_type: data.reference_type
        });
        if (landing_flag) {
          _this16.getLandingPage(data.reference_uid);
        }
      });
    }
  }, {
    key: 'getLandingPage',
    value: function getLandingPage(landingId) {
      var _this17 = this;

      this.props.getLanding(landingId).then(function (data) {
        _this17.setState({
          landingPage: data,
          trackableUrls: true
        });
      });
    }
  }, {
    key: 'getPromotionDetail',
    value: function getPromotionDetail(keyword) {
      var _this18 = this;

      this.props.getPromotionByKeyword(keyword).then(function (data) {
        _this18.setState({
          promotion: data.promotion,
          keyword: keyword
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this19 = this;

      this.props.getAccountStatus().then(function (accountStatus) {
        _this19.setState({ accountStatus: accountStatus });
      });
      var checked = [];
      this.props.getContacts({ monitoring: 'true' }).then(function (data) {
        var withIdentifier = data.map(function (item) {
          if (item.profile.first_name && item.profile.last_name) {
            item.identifier = item.profile.first_name.value + ' ' + item.profile.last_name.value;
          } else {
            item.identifier = item.msisdn;
          }
          return item;
        });
        _this19.setState({ monitoringContacts: withIdentifier });

        data.map(function (item, index) {
          checked[index] = false;
        });
        _this19.setState({ isChecked: checked });
      });
      var short_link = this.props.params.short_link_uid;
      var landing_flag = this.props.params.landing ? true : false;
      short_link ? this.short_link_detail(short_link, landing_flag) : null;
      var keyword = this.props.params.keyword;
      keyword ? this.getPromotionDetail(keyword) : null;
    }
  }, {
    key: 'loadScheduler',
    value: function loadScheduler(formData) {
      this.updateFileStats();
      var data = this.state.fileInfo;
      data.contacts = this.state.files;
      data.form = formData;
      data.file_columns = this.state.fileInfo.variablesPreview.length;
      data.fileUploadResult = this.state.fileUploadResult;
      data.link_uid = this.props.params.short_link_uid;
      data.trackable_urls = this.state.trackableUrls;

      data.tags = this.state.tags;

      if (this.state.messagePreview.message !== '') {
        data.message = this.state.messagePreview.message;
        data.customMessage = true;
      } else {
        data.message = (0, _translations2.default)('MESSAGE ON FILE');
      }

      data.fileStats = this.state.fileStats;

      if (data.fileStats) {
        var propsToSend = {
          pathname: '/messages/scheduler',
          state: {
            modal: true,
            loading: true,
            modalSize: { height: '600px', width: '900px' },
            returnTo: '/messages/',
            data: data
          }
        };
        this.props.push(propsToSend);
      }
    }
  }, {
    key: 'sendMessageScheduled',
    value: function sendMessageScheduled() {
      if (this.state.messagePreview.message !== '') {
        this.formData.append('message', this.state.messagePreview.message);
      }
      this.formData.append('country_code', null);
      this.formData.append('message_from_file', this.state.messageInFile);
      this.formData.append('created_by', this.props.user.username);
      this.loadScheduler(this.formData);
    }
  }, {
    key: 'sendMessageNow',
    value: function sendMessageNow() {
      var _this20 = this;

      if (this.state.fileStats) {
        var data = {};
        if (this.state.messagePreview.message !== '') {
          data.message = this.state.messagePreview.message;
        }

        data.message_from_file = this.state.messageInFile;
        data.created_by = this.props.user.username;
        data._id = this.state.fileUploadResult._id;
        data.file_format = this.validateFileFormat(this.state.messagePreview.message);
        data.channel_type = 'SMS';
        data.monitoring_contacts = this.state.selectedMonitoringContacts;
        data.link_uid = this.props.params.short_link_uid;
        data.short_link = this.state.short_link;
        data.trackable_urls = this.state.trackableUrls;

        var tagList = this.state.tags.map(function (t) {
          return t.value;
        });
        data.tags = tagList.join(',');

        if (this.state.messageInFile) {
          var _fileInformation = this.state.fileInfo.dataFile[0];
          for (var key in _fileInformation) {
            key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
            if (!this.validateMessage(key.toUpperCase())) {
              data.default_message = this.state.fileInfo.dataFile[0][key];
            }
          }
        }

        this.props.messageConfirmSendFile(data, _messages.channelTypes.SMS).then(function (data) {
          _this20.formData = null;
          _this20.setState({
            selecting: false,
            files: []
          });
          _this20.state.tags.forEach(function (tag) {
            _this20.props.incrementTagFileCount(tag.value, tag.id);
          });
          _this20.props.push({
            pathname: '/success',
            state: {
              goTo: '' + _this20.url, goToModal: false,
              message: (0, _translations2.default)('MESSAGE SEND SUCCESS'),
              modal: !_this20.props.mobileMode, returnTo: '' + _this20.url
            }
          });
        }).catch(function (e) {
          console.error('could not send to file', e);
          _this20.props.push({
            pathname: '/fail',
            state: {
              goTo: '' + _this20.url, goToModal: false,
              message: e.message,
              modal: true, returnTo: '' + _this20.url
            }
          });
        });
      }
    }
  }, {
    key: 'onTextAreaChange',
    value: function onTextAreaChange(event) {
      this.setState({ messagePreview: { message: event.target.value }, validateChangeMessage: false, validateChangeTestMessage: false, testFileStats: null });
    }
  }, {
    key: 'onClickVariableMessagePreview',
    value: function onClickVariableMessagePreview(variable) {
      var messageTextArea = this.textAreaRef.current;
      var index = messageTextArea.selectionStart;
      var oldMessage = this.state.messagePreview.message;
      var newMessage = oldMessage.slice(0, index) + '{' + variable + '}' + oldMessage.slice(index);
      var messageCompose = { message: newMessage };
      this.setState((0, _extends3.default)({}, this.state, {
        messagePreview: messageCompose
      }));
    }
  }, {
    key: 'onFileAdded',
    value: function onFileAdded(filename, formData) {
      var _this21 = this;

      if (this.state.accountStatus && this.state.accountStatus.account_status === 'ACTIVE') {
        this.formData = formData;
        this.setState((0, _extends3.default)({}, this.state, {
          selecting: false,
          files: [filename],
          sending: this.state.fileStats != null ? false : true
        }), function () {
          _this21.getFileStats(formData);
        });
      } else {
        this.showSnackBar((0, _translations2.default)('ACCOUNT NOT ACTIVE'), 'error');
      }
    }
  }, {
    key: 'validateFileFormat',
    value: function validateFileFormat(message_from_file) {
      var file_format = 'SMS_MESSAGE';
      var file_columns = this.state.fileInfo.variablesPreview.length;
      var isCustom = !this.state.messageInFile;

      if (file_columns === 0 && isCustom === true) {
        file_format = 'SMS';
      } else {
        if (isCustom == false && message_from_file === true) {
          file_format = 'SMS_MESSAGE';
        }
        if (isCustom == true) {
          file_format = 'SMS_VARS';
        }
      }
      return file_format;
    }
  }, {
    key: 'changeMessageType',
    value: function changeMessageType(value) {

      var fileInformation = this.state.fileInfo.dataFile[0];

      if ((0, _keys2.default)(fileInformation).length === 1) {
        value = false;
      }

      this.setState((0, _extends3.default)({}, this.state, {
        messageInFile: value
      }));
    }
  }, {
    key: 'getFileStats',
    value: function getFileStats(formData) {
      var _this22 = this;

      var isTestFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.state.sending = !isTestFile;
      var fileWithMeta = formData;
      fileWithMeta.append('created_by', this.props.user.email);
      fileWithMeta.append('channel_type', 'SMS');
      fileWithMeta.message = this.state.messagePreview.message;
      fileWithMeta.link_uid = this.props.params.short_link_uid;
      fileWithMeta.append('file_format', this.validateFileFormat(this.state.messagePreview.message));
      console.log("reference_type: ", this.state.reference_type);
      fileWithMeta.append('usage', this.props.params.landing ? 'LANDING' : this.state.reference_type === 'MULTIMEDIA_FILE' ? 'MULTIMEDIA_MESSAGE' : 'MESSAGES');
      // if (fileWithMeta.message !== ""){
      this.props.messageSendFile(fileWithMeta, _messages.channelTypes.SMS).then(function (data) {
        if (!isTestFile) {
          _this22.state.fileUploadResult = data;
          _this22.updateFileStats();
        } else {
          _this22.state.testFileUploadResult = data;
          _this22.updateTestFileStats();
        }
      });
      // }else{
      //   this.state.sending = false
      // }
    }
  }, {
    key: 'validateShortLink',
    value: function validateShortLink(text, url) {
      if (text == null) {
        return true;
      } else {
        if (this.props.params.short_link_uid) {
          if (text.search(url) == -1 || text.length == 0) {
            this.setState({ validateChangeMessage: false, validateChangeTestMessage: false });
            setTimeout(function () {
              alert('El link asociado no se encuentra dentro del texto del mensaje, por favor validar');
            }, 0);
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    }
  }, {
    key: 'validateStats',
    value: function validateStats(balance, messages) {
      if (balance < messages) {
        this.setState({ validateChangeMessage: false });
        setTimeout(function () {
          alert('Saldo insuficiente. Contacta a tu administrador para gestionar el saldo adicional.');
        }, 0);
      } else {
        this.setState({ validateChangeMessage: true });
      }
    }
  }, {
    key: 'validateTestStats',
    value: function validateTestStats(balance, messages) {
      if (balance < messages) {
        this.setState({ validateChangeTestMessage: false });
        setTimeout(function () {
          alert('Saldo insuficiente. Contacta a tu administrador para gestionar el saldo adicional.');
        }, 0);
      } else {
        this.setState({ validateChangeTestMessage: true });
      }
    }
  }, {
    key: 'updateFileStats',
    value: function updateFileStats() {
      var _this23 = this;

      var file_data = {
        _id: this.state.fileUploadResult._id
      };
      file_data.message = this.state.messagePreview.message || this.state.fileInfo.message;
      var file_format = this.validateFileFormat(false);
      file_data.file_format = file_format;
      var _fileStats = null;
      file_data.channel_type = 'SMS';
      file_data.link_uid = this.props.params.short_link_uid;
      if (this.state.selectedMonitoringContacts.length !== 0) {
        file_data.monitoring_contacts = this.state.selectedMonitoringContacts;
      }

      if (this.state.messageInFile) {
        var _fileInformation2 = this.state.fileInfo.dataFile[0];
        for (var key in _fileInformation2) {
          key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
          if (!this.validateMessage(key.toUpperCase())) {
            file_data.default_message = this.state.fileInfo.dataFile[0][key];
          }
        }
      }
      file_data.trackable_urls = this.state.trackableUrls;
      console.log('this props', this.props);
      file_data.short_link_base_url = this.props.account.reach.short_link_base_url;
      var valid = this.validateShortLink(file_data.message, this.state.short_link);
      if (valid) {
        this.props.messageUpdateFileStats(file_data, _messages.channelTypes.SMS).then(function (fileStats) {
          _this23.state.fileStats = fileStats;
          _fileStats = fileStats;
          var credit = _this23.props.balance.current_package;
          _this23.validateStats(credit.balance, _fileStats.total_messages);
          if (_fileStats.lines_ok >= 800000) {
            _this23.setState({
              exceedsFileLimit: true,
              validateChangeMessage: false
            });
          }
          if (_this23.state.promotion) {
            if (!file_data.message.includes(_this23.state.keyword)) {
              _this23.setState({
                keywordValidationFailed: true,
                validateChangeMessage: false
              });
            }
          }
        }).finally(function () {
          _this23.state.sending = false;
          _this23.forceUpdate();
        });
      }
      return _fileStats;
    }
  }, {
    key: 'getTestFileStats',
    value: function getTestFileStats() {
      var _this24 = this;

      var csvHeader = "telefono,mensaje";
      var fileVariables = [];
      var testMessages = [];

      this.state.fileInfo.variablesPreview.forEach(function (item, key) {
        fileVariables.push(item.props.children[1]);
        csvHeader += ',' + item.props.children[1];
      });
      testMessages.push(csvHeader);
      this.state.testNumbers.forEach(function (number) {
        var message = _this24.state.messagePreview.message;
        if (_this24.state.messageInFile) {
          var _fileInformation3 = _this24.state.fileInfo.dataFile[0];
          for (var key in _fileInformation3) {
            key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
            if (!_this24.validateMessage(key.toUpperCase())) {
              message = _this24.state.fileInfo.dataFile[0][key];
            }
          }
        }
        var data = _this24.state.fileInfo;
        data.message = message;
        _this24.setState({
          fileInfo: data
        });
        var csvLine = '\n' + number + ',"' + message.replaceAll(/\n/g, "\\n") + '"';
        fileVariables.forEach(function (item, key) {
          csvLine += ',"' + _this24.state.fileInfo.dataFile[0][item] + '"';
        });
        testMessages.push(csvLine);
      });
      _papaparse2.default.parse(testMessages.toString(), {
        header: true,
        skipEmptyLines: true,
        preview: 10,
        complete: function complete(results) {
          var filetype = 'msisdn';
          var data = new FormData();
          data.append('file_type', filetype);
          data.append('delimiter', results.meta.delimiter);
          var filename = _this24.state.files[0].replace('.csv', '') + '_prueba_' + (0, _moment2.default)().format('YYYY-MM-DD_HH-mm-ss') + '.csv';
          var blob = new Blob([testMessages.toString()], { type: 'text/csv' });
          var file = new File([blob], filename, { type: "text/csv" });
          data.append('file', file);
          data.append('parent_file_uid', _this24.state.fileUploadResult._id);
          _this24.getFileStats(data, true);
        }
      });
      return false;
    }
  }, {
    key: 'updateTestFileStats',
    value: function updateTestFileStats() {
      var _this25 = this;

      var file_data = {
        _id: this.state.testFileUploadResult._id
      };
      file_data.message = this.state.messagePreview.message || this.state.fileInfo.message;
      var file_format = this.validateFileFormat(false);
      file_data.file_format = file_format;
      var _fileStats = null;
      file_data.channel_type = 'SMS';
      file_data.link_uid = this.props.params.short_link_uid;
      if (this.state.selectedMonitoringContacts.length !== 0) {
        file_data.monitoring_contacts = this.state.selectedMonitoringContacts;
      }

      if (this.state.messageInFile) {
        var _fileInformation4 = this.state.fileInfo.dataFile[0];
        for (var key in _fileInformation4) {
          key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
          if (!this.validateMessage(key.toUpperCase())) {
            file_data.default_message = this.state.fileInfo.dataFile[0][key];
          }
        }
      }
      var valid = this.validateShortLink(file_data.message, this.state.short_link);
      if (valid) {
        this.props.messageUpdateFileStats(file_data, _messages.channelTypes.SMS).then(function (fileStats) {
          _this25.state.testFileStats = fileStats;
          _fileStats = fileStats;
          var credit = _this25.props.balance.current_package;
          _this25.validateTestStats(credit.balance, _fileStats.total_messages);
        }).finally(function () {
          // this.state.sending = false
          _this25.forceUpdate();
        });
      }
      return _fileStats;
    }
  }, {
    key: 'sendTestFile',
    value: function sendTestFile() {
      var _this26 = this;

      if (this.state.testFileStats) {
        var data = {};
        if (this.state.messagePreview.message !== '') {
          data.message = this.state.messagePreview.message;
        }

        data.message_from_file = this.state.messageInFile;
        data.created_by = this.props.user.username;
        data._id = this.state.testFileUploadResult._id;
        data.file_format = this.validateFileFormat(this.state.messagePreview.message);
        data.channel_type = 'SMS';
        // data.monitoring_contacts = this.state.selectedMonitoringContacts;
        data.link_uid = this.props.params.short_link_uid;
        data.short_link = this.state.short_link;
        data.trackable_urls = this.state.testTrackableUrls;

        if (this.state.messageInFile) {
          var _fileInformation5 = this.state.fileInfo.dataFile[0];
          for (var key in _fileInformation5) {
            key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
            if (!this.validateMessage(key.toUpperCase())) {
              data.default_message = this.state.fileInfo.dataFile[0][key];
            }
          }
        }

        this.props.messageConfirmSendFile(data, _messages.channelTypes.SMS).then(function (data) {
          _this26.setState({
            validateChangeTestMessage: false,
            testFileStats: []
          });
          alert('Archivo de prueba enviado con \xE9xito.');
        }).catch(function (e) {
          console.error('could not send to file', e);
          _this26.setState({
            validateChangeTestMessage: false,
            testFileStats: []
          });
          alert('No se pudo enviar el archivo de prueba.');
        });
      }
    }
  }, {
    key: 'readFileData',
    value: function readFileData(dataFile) {
      var fileInfo = {
        counter: dataFile.length,
        messagePreview: [],
        contactsPreview: [],
        dataFile: dataFile,
        message: null,
        contacts: [],
        events: [],
        variablesPreview: []
      };

      var fileInformation = fileInfo.dataFile[0];
      for (var key in fileInformation) {
        key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
        if (this.validatePhone(key.toUpperCase()) && this.validateMessage(key.toUpperCase())) {
          fileInfo.variablesPreview.push(_react2.default.createElement(
            'div',
            { className: _Message5.default.tag, onClick: this.onClickVariableMessagePreview.bind(this, key) },
            ' ',
            key,
            ' '
          ));
        } else if (!this.validateMessage(key.toUpperCase())) {
          this.setState({
            messageInFile: true
          });
        }
      }

      if (this.props.params.landing) {
        var missingLandingTags = this.checkLandingTagsInFileInformation(this.state.landingPage.tags, fileInformation);

        for (var ltag in missingLandingTags) {
          fileInfo.variablesPreview.push(_react2.default.createElement(
            'div',
            { className: _Message5.default.missingTag, style: { display: 'flex', justifyContent: 'space-between', padding: '0 15%', color: '#000' }, onClick: function onClick() {
                return console.log('missing tag');
              } },
            ' ',
            ltag,
            ' ',
            this.renderMissingTagsTooltip(ltag),
            ' '
          ));
        }
      }

      fileInfo.messagesPreview = dataFile.map(function (item, index) {

        if (index >= 3) {
          return null;
        } else {
          fileInfo.contactsPreview.push(_react2.default.createElement(
            'div',
            { className: _Message5.default.numbers },
            _react2.default.createElement(md.person, { className: _Message5.default.icon }),
            _react2.default.createElement(
              'h1',
              null,
              ' +',
              item[(0, _keys2.default)(item)[0]],
              ' '
            )
          ));
          return _react2.default.createElement(
            'div',
            { className: _Message5.default.container },
            _react2.default.createElement(
              'div',
              { className: _Message5.default.text },
              _react2.default.createElement(
                'div',
                { className: _Message5.default.number },
                _react2.default.createElement(
                  'h1',
                  null,
                  ' ',
                  item[(0, _keys2.default)(item)[0]],
                  '  '
                )
              ),
              _react2.default.createElement(
                'h1',
                null,
                ' ',
                (0, _keys2.default)(item)[1] ? item[(0, _keys2.default)(item)[1]] : (0, _translations2.default)('NO MESSAGE'),
                ' '
              )
            )
          );
        }
      });

      this.setState((0, _extends3.default)({}, this.state, {
        fileInfo: fileInfo
      }));
    }
  }, {
    key: 'insertVariable',
    value: function insertVariable(value) {
      for (var key in fileInformation) {
        fileInfo.variablesPreview.push(_react2.default.createElement(
          'div',
          { className: _Message5.default.tag },
          ' ',
          key,
          ' '
        ));
      }
    }
  }, {
    key: 'changeFile',
    value: function changeFile() {
      this.setState((0, _extends3.default)({}, this.state, {
        messageInFile: false,
        fileStats: null,
        testFileStats: null,
        fileInfo: {
          counter: 0,
          messagesPreview: [],
          contactsPreview: [],
          variablesPreview: [],
          dataFile: null,
          message: null,
          contacts: [],
          events: []
        },
        validateChangeMessage: false,
        validateChangeTestMessage: false,
        messagePreview: { message: '' },
        files: [],
        selectedMonitoringContacts: [],
        isChecked: this.state.isChecked.map(function () {
          return false;
        }),
        trackableUrls: false,
        testTrackableUrls: false,
        testNumbers: [],
        testTagNumbers: [],
        exceedsFileLimit: false
      }));
    }
  }, {
    key: 'deleteFromSelected',
    value: function deleteFromSelected(i) {
      this.props.unselect(i);
    }
  }, {
    key: 'addSelectedMonitoringContact',
    value: function addSelectedMonitoringContact(contact) {
      var _this27 = this;

      var newMonitoringContacts = [].concat((0, _toConsumableArray3.default)(this.state.selectedMonitoringContacts), [contact]);
      this.setState({ selectedMonitoringContacts: newMonitoringContacts }, function () {
        if (_this27.state.messageInFile) {
          _this27.updateFileStats();
        }
      });
    }
  }, {
    key: 'deleteSelectedMonitoringContact',
    value: function deleteSelectedMonitoringContact(id) {
      var _this28 = this;

      var newMonitoringContacts = this.state.selectedMonitoringContacts.filter(function (contact) {
        return contact.id !== id;
      });
      this.setState({ selectedMonitoringContacts: newMonitoringContacts }, function () {
        if (_this28.state.messageInFile) {
          _this28.updateFileStats();
        }
      });
    }
  }, {
    key: 'concatShortLink',
    value: function concatShortLink() {
      var text = this.state.messagePreview.message;
      text = text + this.state.short_link;
      this.setState({ messagePreview: { message: text }, validateChangeMessage: false });
    }
  }, {
    key: 'concatKeyword',
    value: function concatKeyword() {
      var text = this.state.messagePreview.message;
      text = text + this.state.keyword;
      this.setState({ messagePreview: { message: text }, validateChangeMessage: false });
    }
  }, {
    key: 'onCLickHandle',
    value: function onCLickHandle(rowInfo) {
      var isCheckArray = this.state.isChecked;
      var check = isCheckArray[rowInfo.index];

      if (check) {
        check = false;
        this.deleteSelectedMonitoringContact(rowInfo.original.id);
      } else {
        check = true;
        this.addSelectedMonitoringContact(rowInfo.original);
      }
      isCheckArray[rowInfo.index] = check;
      this.setState({ isChecked: isCheckArray, validateChangeMessage: false });
    }
  }, {
    key: 'handleTagsChange',
    value: function handleTagsChange(tags) {
      var _this29 = this;

      this.setState((0, _extends3.default)({}, this.state, {
        tags: tags
      }));
      var objetosSinId = [];
      for (var i = 0; i < tags.length; i++) {
        if (!tags[i].hasOwnProperty('id')) {
          objetosSinId.push(tags[i]);
        }
      }
      objetosSinId.forEach(function (objeto) {
        console.log(objeto.value);
        var dataSend = {
          name: objeto.value,
          enable: true,
          stats: {
            contacts_count: 0,
            conversations_count: 0,
            files_count: 0
          }
        };
        _this29.props.createTagsRefactor(dataSend);
      });
    }
  }, {
    key: 'renderMonitoringContacts',
    value: function renderMonitoringContacts() {
      var _this30 = this;

      var columns = [{
        id: 'identifier',
        accessor: 'identifier',
        filterable: true,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Checkbox2.default, {
              size: 'small',
              checked: _this30.state.isChecked[props.index],
              color: 'primary', original: true,
              inputProps: { 'aria-label': 'secondary checkbox' }
            }),
            _react2.default.createElement(_components.CarrierIcon, { profile: props.original, detail: true })
          );
        }
      }];

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.selector },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.table },
          _react2.default.createElement(
            'h1',
            { className: _Message5.default.labelContainer },
            'Contactos de monitoreo'
          ),
          _react2.default.createElement(_reactTable2.default, {
            columns: columns,
            filterable: true,
            data: this.state.monitoringContacts,
            getTrProps: function getTrProps(state, rowInfo) {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: function onClick(e) {
                    _this30.onCLickHandle(rowInfo);
                  },
                  style: {
                    background: _this30.isIn(rowInfo.original) ? '#BEC4D0' : 'white',
                    fontWeight: _this30.isIn(rowInfo.original) ? 'bold' : 'unset',
                    color: _this30.isIn(rowInfo.original) ? '#060D3B' : 'black',
                    cursor: 'pointer'
                  }
                };
              } else {
                return {};
              }
            }
          })
        )
      );
    }
  }, {
    key: 'renderTestMessageSender',
    value: function renderTestMessageSender() {
      var _this31 = this;

      return this.state.testing ? _react2.default.createElement(
        'div',
        { className: _Message5.default.testingContainerOpen },
        _react2.default.createElement(
          'div',
          { onClick: this.turnTesting },
          _react2.default.createElement('img', { className: _Message5.default.testingIcon, src: (0, _useBasename2.default)('/static/arrow_blue.svg'), alt: '' }),
          _react2.default.createElement(
            'label',
            { className: _Message5.default.labelTesting },
            'Hacer env\xEDo de prueba'
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'label',
          { className: _Message5.default.labelExample },
          'Tel\xE9fonos de prueba (Ej.: 50212345678)'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.tagContainer },
          _react2.default.createElement(_components.ChipSelect, {
            value: this.state.testTagNumbers,
            onChange: this.handleGetNumbers,
            className: _Message5.default['react-tagsinput'],
            focusedClassName: _Message5.default['react-tagsinput--focused'],
            tagProps: { className: _Message5.default['react-tagsinput-tag'], classNameRemove: _Message5.default['react-tagsinput-remove'] },
            inputProps: { className: _Message5.default['react-tagsinput-input'], placeholder: "Teléfonos de prueba" }
          }),
          _react2.default.createElement(
            'button',
            { type: 'button', className: _Message5.default.estimateButon, onClick: this.state.testNumbers.length > 0 ? this.getTestFileStats : function () {
                return alert('Debes ingresar al menos un número de teléfono.');
              } },
            (0, _translations2.default)('BUTTON TOTAL MESSAGES')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.traceContainer },
          (0, _featureEnabled.featureEnabled)('trackable-urls') && _react2.default.createElement(
            'div',
            { className: _Message5.default.trackableContainer },
            _react2.default.createElement('input', { type: 'checkbox', onChange: function onChange() {
                return _this31.setState({ testTrackableUrls: !_this31.state.testTrackableUrls });
              } }),
            '\xA0',
            _react2.default.createElement(
              'label',
              { className: _Message5.default.labelExample },
              (0, _translations2.default)('TRACKABLE URLS')
            ),
            this.renderTooltip((0, _translations2.default)('TRACKABLE URLS'), (0, _translations2.default)('TRACKABLE URLS DESCRIPTION'))
          ),
          this.state.testFileStats && _react2.default.createElement(
            'label',
            { className: _Message5.default.labelExample },
            'Total de mensajes de prueba: ',
            this.state.testFileStats.total_messages ? this.state.testFileStats.total_messages.toLocaleString() : 0
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.sentContainer },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: this.state.validateChangeTestMessage && this.state.testNumbers && this.state.testFileStats.total_messages > 0 ? _Message5.default.sentButton : _Message5.default.nowDisabled,
              onClick: this.state.validateChangeTestMessage && this.state.testNumbers && this.state.testFileStats.total_messages > 0 ? this.sendTestFile : null
            },
            'Enviar archivo de prueba'
          )
        )
      ) : _react2.default.createElement(
        'div',
        { className: _Message5.default.testingContainer, onClick: this.turnTesting },
        _react2.default.createElement('img', { className: _Message5.default.testingIcon, src: (0, _useBasename2.default)('/static/arrow-back.svg'), alt: '' }),
        _react2.default.createElement(
          'label',
          { className: _Message5.default.labelTesting },
          'Hacer env\xEDo de prueba'
        )
      );
    }
  }, {
    key: 'renderSelector',
    value: function renderSelector() {
      var _this32 = this;

      var selectedClassNames = _Message5.default.selected + ' ' + (this.props.mobileMode ? ' ' + _Message5.default.mobile : '');

      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(_Message5.default); //IF THEME
      var assetStyle = (0, _themeEnabled.getAssetStyle)();
      var iconCSV = assetStyle.iconCSV;
      var iconContac = assetStyle.iconContac;
      var iconMessage = assetStyle.iconMessage;

      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: this.styles.selectorDropZone },
          _react2.default.createElement(_reactHelmet2.default, { title: "Nuevo mensaje" }),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.hintsContainer },
            _react2.default.createElement(
              'div',
              { className: _Message5.default.instructionContainer },
              _react2.default.createElement(
                'div',
                { className: _Message5.default.hintContainer },
                _react2.default.createElement('img', { className: _Message5.default.exampleIcon, src: iconCSV }),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.headerContainer },
                  (0, _translations2.default)('CSV HINT')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _Message5.default.hintContainer },
                _react2.default.createElement('img', { className: _Message5.default.exampleIcon, src: iconContac }),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.headerContainer },
                  (0, _translations2.default)('CONTACT HINT')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _Message5.default.hintContainer },
                _react2.default.createElement('img', { className: _Message5.default.exampleIcon, src: iconMessage }),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.headerContainer },
                  (0, _translations2.default)('MESSAGE HINT')
                )
              ),
              this.state.landingPage && this.state.landingPage.tags ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'a',
                  { className: this.styles.download, onClick: function onClick() {
                      return (0, _LinkList.generateCSV)(_this32.state.landingPage.tags, '50240000101');
                    }, download: true },
                  _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/saveAlt.svg') }),
                  _react2.default.createElement(
                    'div',
                    null,
                    (0, _translations2.default)('FILE TEMPLATE DOWNLOAD')
                  )
                )
              ) : this.state.messageInFile ? _react2.default.createElement(
                'a',
                { className: this.styles.download, href: 'https://s3.amazonaws.com/public-im-resources/csm-sample-3.csv', download: true },
                _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/saveAlt.svg') }),
                _react2.default.createElement(
                  'div',
                  null,
                  (0, _translations2.default)('FILE TEMPLATE DOWNLOAD')
                )
              ) : _react2.default.createElement(
                'a',
                { className: this.styles.download, href: 'https://s3.amazonaws.com/public-im-resources/csm-sample-2.csv', download: true },
                _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/saveAlt.svg') }),
                _react2.default.createElement(
                  'div',
                  null,
                  (0, _translations2.default)('FILE TEMPLATE DOWNLOAD')
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: _Message5.default.divider }),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.dropZoneHolder },
            _react2.default.createElement(
              'div',
              { className: classesTheme },
              this.props.params.short_link_uid ? _react2.default.createElement(
                'div',
                null,
                this.state.link_name ? _react2.default.createElement(
                  'div',
                  { className: _Message5.default.linkHolder },
                  this.state.link_name
                ) : '',
                _react2.default.createElement('div', { className: _Message5.default.separator }),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.linkHolder },
                  _react2.default.createElement('img', { className: _Message5.default.linkIcon2, src: (0, _useBasename2.default)('/static/link.svg') }),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.link },
                    this.state.short_link
                  )
                )
              ) : '',
              this.state.promotion ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.linkHolder },
                  this.state.promotion.name
                ),
                _react2.default.createElement('div', { className: _Message5.default.separator }),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.linkHolder },
                  'Palabra clave: ',
                  this.state.keyword
                )
              ) : '',
              _react2.default.createElement(_components.DropZone, {
                onFileAdded: this.onFileAdded.bind(this),
                mobileMode: this.props.mobileMode,
                shortlink: this.props.params.short_link_uid,
                readFileData: this.readFileData.bind(this) }),
              _react2.default.createElement(
                'div',
                { className: selectedClassNames },
                this.renderSelected()
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderDate',
    value: function renderDate() {
      return _react2.default.createElement(
        'div',
        { className: _Message5.default.scheduledFor },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.label },
          (0, _translations2.default)('SEND WHEN'),
          ':'
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.date },
          this.state.scheduledText ? this.state.scheduledText : (0, _translations2.default)('NOW')
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.button },
          _react2.default.createElement(md.calendar, { size: 30, onClick: this.handleScheduling })
        )
      );
    }
  }, {
    key: 'renderSelected',
    value: function renderSelected() {
      var styles = this.styles;
      return this.state.files.map(function (s) {
        return _react2.default.createElement(
          'div',
          { key: s, className: styles.title },
          s
        );
      });
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip(title, description) {
      return _react2.default.createElement(
        _Tooltip2.default,
        { className: _Message5.default.tooltip, title: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'h2',
              { color: 'inherit' },
              title
            ),
            _react2.default.createElement(
              'h3',
              null,
              description
            )
          ), placement: 'top', arrow: true },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_Info2.default, { color: 'primary' })
        )
      );
    }
  }, {
    key: 'renderMissingTagsTooltip',
    value: function renderMissingTagsTooltip(tag) {
      return _react2.default.createElement(
        _Tooltip2.default,
        { title: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'span',
              { color: 'inherit' },
              tag
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Esta etiqueta no se encuentra en el archivo'
            )
          ), placement: 'top', arrow: true },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_Info2.default, { color: 'secondary' })
        )
      );
    }
  }, {
    key: 'renderMessageInFilePlaceHolder',
    value: function renderMessageInFilePlaceHolder() {
      var _this33 = this;

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.messageInFile },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.banner },
          this.state.fileInfo.messagesPreview,
          (0, _featureEnabled.featureEnabled)('messages-files-test') && this.renderTestMessageSender(),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.wrapper },
            _react2.default.createElement(
              'div',
              { className: _Message5.default.footer },
              this.state.fileStats ? _react2.default.createElement(
                'div',
                { className: _Message5.default.containerLeft },
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.left },
                  _react2.default.createElement(
                    'h1',
                    null,
                    ' ',
                    (0, _translations2.default)('LENGHT')
                  ),
                  _react2.default.createElement(
                    'h1',
                    null,
                    ' de '
                  ),
                  _react2.default.createElement(
                    'h1',
                    null,
                    ' ',
                    (0, _translations2.default)('MESSAGES'),
                    ' '
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.right },
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.stats },
                    _react2.default.createElement(
                      'h1',
                      null,
                      (0, _translations2.default)('LONGEST'),
                      ' '
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      ' ',
                      this.state.fileStats.long_message_length.toLocaleString(),
                      ' caracteres '
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.stats },
                    _react2.default.createElement(
                      'h1',
                      null,
                      (0, _translations2.default)('SHORTEST')
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      ' ',
                      this.state.fileStats.short_message_length.toLocaleString(),
                      ' caracteres '
                    )
                  )
                )
              ) : _react2.default.createElement(
                'div',
                { className: _Message5.default.containerLeft },
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.error },
                  ' ',
                  (0, _translations2.default)('ERROR CALCULATING'),
                  ' '
                )
              ),
              this.state.fileStats ? _react2.default.createElement(
                'div',
                { className: _Message5.default.containerLeft },
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.left },
                  _react2.default.createElement(
                    'h1',
                    null,
                    (0, _translations2.default)('ROWS')
                  ),
                  _react2.default.createElement(
                    'h1',
                    null,
                    ' en '
                  ),
                  _react2.default.createElement(
                    'h1',
                    null,
                    ' ',
                    (0, _translations2.default)('FILE'),
                    ' '
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.right },
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.stats },
                    _react2.default.createElement(
                      'h1',
                      null,
                      (0, _translations2.default)('DUPLICATED')
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      this.state.fileStats.lines_error.duplicates.toLocaleString()
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.stats },
                    _react2.default.createElement(
                      'h1',
                      null,
                      (0, _translations2.default)('ERROR')
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      this.state.fileStats.lines_error.total_error.toLocaleString()
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.stats },
                    _react2.default.createElement(
                      'h1',
                      null,
                      (0, _translations2.default)('MONITORING')
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      this.state.fileStats.monitoring_messages.toLocaleString()
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.stats },
                    _react2.default.createElement(
                      'h1',
                      null,
                      (0, _translations2.default)('OK')
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      this.state.fileStats.lines_ok.toLocaleString()
                    )
                  )
                )
              ) : _react2.default.createElement(
                'div',
                { className: _Message5.default.containerLeft },
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.error },
                  ' ',
                  (0, _translations2.default)('ERROR CALCULATING'),
                  ' '
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _Message5.default.footer },
              _react2.default.createElement(
                'div',
                { className: _Message5.default.mainContainer },
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.container },
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.left },
                    _react2.default.createElement(
                      'h1',
                      null,
                      ' ',
                      (0, _translations2.default)('TOTAL')
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      ' de '
                    ),
                    _react2.default.createElement(
                      'h1',
                      null,
                      ' ',
                      (0, _translations2.default)('MESSAGES'),
                      ' '
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.right },
                    _react2.default.createElement(
                      'div',
                      { className: _Message5.default.number },
                      _react2.default.createElement(
                        'h2',
                        null,
                        this.state.fileStats ? this.state.fileStats.total_messages.toLocaleString() : 0
                      )
                    )
                  )
                ),
                (0, _featureEnabled.featureEnabled)('trackable-urls') ? _react2.default.createElement(
                  'div',
                  { className: _Message5.default.totalContainer },
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.trackableContainer },
                    _react2.default.createElement(_Checkbox2.default, {
                      disabled: this.state.landingPage,
                      size: 'small',
                      checked: this.state.trackableUrls,
                      color: 'primary',
                      onChange: function onChange() {
                        return _this33.setState({ trackableUrls: !_this33.state.trackableUrls });
                      }
                    }),
                    _react2.default.createElement(
                      'span',
                      null,
                      (0, _translations2.default)('TRACKABLE URLS')
                    ),
                    this.renderTooltip((0, _translations2.default)('TRACKABLE URLS'), (0, _translations2.default)('TRACKABLE URLS DESCRIPTION'))
                  )
                ) : null
              ),
              _react2.default.createElement(
                'div',
                { className: _Message5.default.buttons },
                _react2.default.createElement(
                  'button',
                  { type: 'button', className: _Message5.default.now, onClick: this.sendMessageNow },
                  (0, _translations2.default)('NOTICE OK')
                ),
                _react2.default.createElement(
                  'button',
                  { type: 'button', className: _Message5.default.schedule, onClick: this.sendMessageScheduled },
                  (0, _translations2.default)('SCHEDULE')
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderEstimatedTime',
    value: function renderEstimatedTime() {
      if (!this.state.fileStats) return null;
      var processingTime = this.state.fileStats.estimated_processing_min;
      var sendingTime = this.state.fileStats.estimated_sending_min;
      var totalTime = processingTime + sendingTime;
      totalTime = totalTime === 2 ? 1 : totalTime;

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.wrapper },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.footer },
          _react2.default.createElement(
            'div',
            { className: _Message5.default.containerLeft },
            _react2.default.createElement(
              'div',
              { className: _Message5.default.left },
              _react2.default.createElement(
                'h1',
                null,
                (0, _translations2.default)('TIME')
              ),
              _react2.default.createElement(
                'h1',
                null,
                (0, _translations2.default)('ESTIMATED')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _Message5.default.right },
              _react2.default.createElement(
                'div',
                { className: _Message5.default.stats },
                _react2.default.createElement(
                  'h1',
                  null,
                  (0, _translations2.default)('PROCESSING')
                ),
                _react2.default.createElement(
                  'h1',
                  null,
                  (0, _getTimeFromMinutes2.default)(processingTime)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _Message5.default.stats },
                _react2.default.createElement(
                  'h1',
                  null,
                  (0, _translations2.default)('SENDING')
                ),
                _react2.default.createElement(
                  'h1',
                  null,
                  (0, _getTimeFromMinutes2.default)(sendingTime)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _Message5.default.stats },
                _react2.default.createElement(
                  'h1',
                  null,
                  (0, _translations2.default)('TOTAL')
                ),
                _react2.default.createElement(
                  'h1',
                  null,
                  (0, _getTimeFromMinutes2.default)(totalTime)
                )
              )
            ),
            this.renderTooltip((0, _translations2.default)('ESTIMATED TIME'), (0, _translations2.default)('ESTIMATED TIME DESCRIPTION'))
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this34 = this;

      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(_Message5.default);

      if (this.state.sending) {
        return _react2.default.createElement(
          'div',
          { className: classesTheme },
          _react2.default.createElement(
            'div',
            { className: _Message5.default.selectorContainer },
            _react2.default.createElement(_components.FileLoading, null)
          )
        );
      } else {}

      // const styles = this.styles
      var files = this.state.files;
      if (files.length === 0) {
        return _react2.default.createElement(
          'div',
          { className: classesTheme },
          this.renderTabs(),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.selectorContainer },
            _react2.default.createElement(_Snackbar2.default, {
              messageText: this.state.snackMessage,
              variant: this.state.snackStatus,
              isOpen: this.state.showSnack,
              autoHideDuration: 2600,
              handleClose: function handleClose() {
                return _this34.setState({ showSnack: false });
              }
            }),
            this.renderSelector()
          )
        );
      }

      if (this.state.selecting) {
        return _react2.default.createElement(
          'div',
          { className: classesTheme },
          _react2.default.createElement(
            'div',
            { className: _Message5.default.message },
            _react2.default.createElement(_components.MobileBar, { title: (0, _translations2.default)('UPLOAD FILE'), extraAction: this.handleSelectionDeactivate, extraIcon: md.close }),
            _react2.default.createElement(_reactHelmet2.default, { title: "Nuevo mensaje por archivo" }),
            this.renderSelector(),
            _react2.default.createElement(
              'div',
              { className: _Message5.default.selectorActions },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: _Message5.default.selectorAction, onClick: this.handleUnselectAll },
                (0, _translations2.default)('CLEAR SELECTION')
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: _Message5.default.selectorAction, onClick: this.handleSelectionDeactivate },
                (0, _translations2.default)('SELECT')
              )
            ),
            _react2.default.createElement(_components.MessageFormContainer, { initialValues: messageValue || "", postMessage: this.sendMessage, key: '2', loading: this.state.sending })
          )
        );
      }

      if (files.length > 0) {
        var changeExample = false;
        var hasVars = true;
        var selectedClassNames = _Message5.default.selected + ' ' + (this.props.mobileMode ? ' ' + _Message5.default.mobile : '');
        var accountStatus = this.state.accountStatus;
        var shortnamePrefixLength = accountStatus && accountStatus.csm && accountStatus.csm.api_use_short_name ? accountStatus.sms_short_name.length + 2 : 0;
        var maxLength = 612 - shortnamePrefixLength;

        var shortName = '';
        if (accountStatus && accountStatus.csm && accountStatus.csm.api_use_short_name === true) {
          shortName = accountStatus.sms_short_name + ': ';
        }
        var messageLength = 160;
        var messageLengthMultiple = 153;

        var _getSmsPreview = (0, _string.getSmsPreview)(shortName, this.state.messagePreview.message, messageLength, messageLengthMultiple),
            _getSmsPreview2 = (0, _slicedToArray3.default)(_getSmsPreview, 2),
            previewText = _getSmsPreview2[0],
            length = _getSmsPreview2[1];

        return _react2.default.createElement(
          'div',
          { className: classesTheme },
          _react2.default.createElement(
            'div',
            { className: _Message5.default.message },
            _react2.default.createElement(_reactHelmet2.default, { title: "Nuevo mensaje por archivo" }),
            this.props.mobileMode ? this.renderMobileBar() : null,
            this.renderTabs(),
            _react2.default.createElement(
              'div',
              { className: _Message5.default.main },
              _react2.default.createElement(
                'div',
                { className: _Message5.default.selectorDropZoneSmall },
                this.props.params.short_link_uid ? _react2.default.createElement(
                  'div',
                  { className: _Message5.default.linkContainer },
                  this.state.link_name ? _react2.default.createElement(
                    'div',
                    { className: _Message5.default.linkHolder },
                    this.state.link_name
                  ) : '',
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.linkButton, onClick: this.concatShortLink.bind(this) },
                    _react2.default.createElement('img', { className: _Message5.default.linkIcon, src: (0, _useBasename2.default)('/static/link.svg') }),
                    _react2.default.createElement(
                      'div',
                      { className: _Message5.default.link },
                      'Presione para agregar link'
                    )
                  )
                ) : '',
                this.state.promotion ? _react2.default.createElement(
                  'div',
                  { className: _Message5.default.linkContainer },
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.linkHolder },
                    this.state.promotion.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.linkHolder },
                    'Palabra clave: ',
                    this.state.keyword
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.linkButton, onClick: this.concatKeyword.bind(this) },
                    _react2.default.createElement(
                      'div',
                      { className: _Message5.default.link },
                      'Presione para agregar promoci\xF3n'
                    )
                  )
                ) : '',
                _react2.default.createElement(
                  'div',
                  { className: hasVars ? _Message5.default.file : _Message5.default.fileWithoutTags },
                  _react2.default.createElement('img', { className: _Message5.default.image, src: (0, _useBasename2.default)('/static/file.svg') }),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.text },
                    this.renderSelected()
                  )
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: this.styles.download, onClick: this.changeFile.bind(this) },
                  ' ',
                  (0, _translations2.default)('CHANGE'),
                  ' '
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.tagsSelect },
                  _react2.default.createElement(
                    'h1',
                    null,
                    ' ',
                    (0, _translations2.default)('REFERENCE')
                  ),
                  _react2.default.createElement(_components.TagsSelect, {
                    placeholder: (0, _translations2.default)('SMS FILE TAGS'),
                    onChange: this.handleTagsChange,
                    value: this.state.tags
                  })
                ),
                hasVars ? _react2.default.createElement(
                  'div',
                  null,
                  this.state.fileInfo.variablesPreview.length > 0 ? _react2.default.createElement(
                    'h1',
                    null,
                    ' ',
                    (0, _translations2.default)('TAGS IN FILE')
                  ) : null,
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.tagsContainer },
                    this.state.fileInfo.variablesPreview
                  )
                ) : null,
                this.state.monitoringContacts.length > 0 ? this.renderMonitoringContacts() : null
              ),
              _react2.default.createElement(
                'div',
                { className: _Message5.default.right },
                !this.props.mobileMode ? _react2.default.createElement(
                  'label',
                  { className: _Message5.default.labelContacts },
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.text },
                    ' ',
                    (0, _translations2.default)('SENDING TO'),
                    ': '
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.container },
                    this.state.fileInfo.contactsPreview
                  )
                ) : null,
                _react2.default.createElement('div', { className: selectedClassNames }),
                _react2.default.createElement(
                  'div',
                  { className: _Message5.default.messageButtons },
                  this.props.params.short_link_uid ? '' : _react2.default.createElement(
                    _reactRouter.Link,
                    { className: _Message5.default.button, style: { background: !this.state.messageInFile ? '#FFF' : '#616161', color: !this.state.messageInFile ? '#616161' : '#FFF' } },
                    (0, _translations2.default)('MESSAGE IN FILE')
                  ),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { className: _Message5.default.button, style: { background: !this.state.messageInFile ? '#616161' : '#FFF', color: !this.state.messageInFile ? '#FFF' : '#616161' } },
                    (0, _translations2.default)('MESSAGE NOT IN FILE')
                  )
                ),
                this.state.messageInFile ? this.renderMessageInFilePlaceHolder() : _react2.default.createElement(
                  'div',
                  { className: _Message5.default.textAreaContainer },
                  _react2.default.createElement('textarea', { ref: this.textAreaRef, className: _Message5.default.messageComposer, value: this.state.messagePreview.message, onChange: this.onTextAreaChange, maxlength: maxLength }),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.previewContainer },
                    _react2.default.createElement(
                      'label',
                      { className: _Message5.default.previewLabel },
                      (0, _translations2.default)('PREVIEW'),
                      ':'
                    ),
                    _react2.default.createElement('div', { className: _Message5.default.previewText, dangerouslySetInnerHTML: { __html: previewText } })
                  ),
                  (0, _featureEnabled.featureEnabled)('messages-files-test') && this.renderTestMessageSender(),
                  this.renderEstimatedTime(),
                  _react2.default.createElement(
                    'div',
                    { className: _Message5.default.wrapper },
                    _react2.default.createElement(
                      'div',
                      { className: _Message5.default.footer },
                      this.state.fileStats ? _react2.default.createElement(
                        'div',
                        { className: _Message5.default.containerLeft },
                        _react2.default.createElement(
                          'div',
                          { className: _Message5.default.left },
                          _react2.default.createElement(
                            'h1',
                            null,
                            ' ',
                            (0, _translations2.default)('LENGHT')
                          ),
                          _react2.default.createElement(
                            'h1',
                            null,
                            ' de '
                          ),
                          _react2.default.createElement(
                            'h1',
                            null,
                            ' ',
                            (0, _translations2.default)('MESSAGES'),
                            ' '
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: _Message5.default.right },
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.stats },
                            _react2.default.createElement(
                              'h1',
                              null,
                              (0, _translations2.default)('LONGEST'),
                              ' '
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              ' ',
                              this.state.fileStats.long_message_length.toLocaleString(),
                              ' caracteres '
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.stats },
                            _react2.default.createElement(
                              'h1',
                              null,
                              (0, _translations2.default)('SHORTEST')
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              ' ',
                              this.state.fileStats.short_message_length.toLocaleString(),
                              ' caracteres '
                            )
                          )
                        )
                      ) : null,
                      this.state.fileStats ? _react2.default.createElement(
                        'div',
                        { className: _Message5.default.containerLeft },
                        _react2.default.createElement(
                          'div',
                          { className: _Message5.default.left },
                          _react2.default.createElement(
                            'h1',
                            null,
                            (0, _translations2.default)('ROWS')
                          ),
                          _react2.default.createElement(
                            'h1',
                            null,
                            ' en '
                          ),
                          _react2.default.createElement(
                            'h1',
                            null,
                            ' ',
                            (0, _translations2.default)('FILE'),
                            ' '
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: _Message5.default.right },
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.stats },
                            _react2.default.createElement(
                              'h1',
                              null,
                              (0, _translations2.default)('DUPLICATED')
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              this.state.fileStats.lines_error.duplicates.toLocaleString()
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.stats },
                            _react2.default.createElement(
                              'h1',
                              null,
                              (0, _translations2.default)('ERROR')
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              this.state.fileStats.lines_error.total_error.toLocaleString()
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.stats },
                            _react2.default.createElement(
                              'h1',
                              null,
                              (0, _translations2.default)('MONITORING')
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              this.state.fileStats.monitoring_messages.toLocaleString()
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.stats },
                            _react2.default.createElement(
                              'h1',
                              null,
                              (0, _translations2.default)('OK')
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              this.state.fileStats.lines_ok.toLocaleString()
                            )
                          )
                        )
                      ) : _react2.default.createElement('div', { className: _Message5.default.containerLeft })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: _Message5.default.footer },
                      _react2.default.createElement(
                        'div',
                        { className: _Message5.default.mainContainer },
                        _react2.default.createElement(
                          'div',
                          { className: _Message5.default.container },
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.left },
                            _react2.default.createElement(
                              'h1',
                              null,
                              ' ',
                              (0, _translations2.default)('TOTAL')
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              ' de '
                            ),
                            _react2.default.createElement(
                              'h1',
                              null,
                              ' ',
                              (0, _translations2.default)('MESSAGES'),
                              ' '
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.right },
                            _react2.default.createElement(
                              'div',
                              { className: _Message5.default.number },
                              _react2.default.createElement(
                                'h2',
                                null,
                                this.state.fileStats ? this.state.fileStats.total_messages.toLocaleString() : 0
                              )
                            )
                          )
                        ),
                        (0, _featureEnabled.featureEnabled)('trackable-urls') ? _react2.default.createElement(
                          'div',
                          { className: _Message5.default.totalContainer },
                          _react2.default.createElement(
                            'button',
                            { type: 'button', className: _Message5.default.totalButton, onClick: this.updateFileStats },
                            (0, _translations2.default)('BUTTON TOTAL MESSAGES')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: _Message5.default.trackableContainer },
                            _react2.default.createElement(_Checkbox2.default, {
                              disabled: this.state.landingPage,
                              size: 'small',
                              checked: this.state.trackableUrls,
                              color: 'primary',
                              onChange: function onChange() {
                                return _this34.setState({ trackableUrls: !_this34.state.trackableUrls });
                              }
                            }),
                            _react2.default.createElement(
                              'span',
                              null,
                              (0, _translations2.default)('TRACKABLE URLS')
                            ),
                            this.renderTooltip((0, _translations2.default)('TRACKABLE URLS'), (0, _translations2.default)('TRACKABLE URLS DESCRIPTION'))
                          )
                        ) : _react2.default.createElement(
                          'button',
                          { type: 'button', className: _Message5.default.totalButton, onClick: this.updateFileStats },
                          (0, _translations2.default)('BUTTON TOTAL MESSAGES')
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: _Message5.default.buttons },
                        _react2.default.createElement(
                          'button',
                          { type: 'button', className: this.state.validateChangeMessage ? _Message5.default.now : _Message5.default.nowDisabled, onClick: this.state.validateChangeMessage ? this.sendMessageNow : null },
                          (0, _translations2.default)('NOTICE OK')
                        ),
                        _react2.default.createElement(
                          'button',
                          { type: 'button', className: this.state.validateChangeMessage ? _Message5.default.schedule : _Message5.default.nowDisabled, onClick: this.state.validateChangeMessage ? this.sendMessageScheduled : null },
                          (0, _translations2.default)('SCHEDULE')
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(_Snackbar2.default, {
                messageText: (0, _translations2.default)('FILE LIMIT EXCEEDED'),
                variant: 'error',
                isOpen: this.state.exceedsFileLimit,
                autoHideDuration: 8000,
                handleClose: this.changeFile
              }),
              _react2.default.createElement(_Snackbar2.default, {
                messageText: (0, _translations2.default)('KEYWORD NOT PRESENT'),
                variant: 'error',
                isOpen: this.state.keywordValidationFailed,
                autoHideDuration: 5000,
                handleClose: function handleClose() {
                  return _this34.setState({ keywordValidationFailed: false });
                }
              })
            )
          )
        );
      }
    }
  }]);
  return MessageToFile;
}(Message), _class11.defaultProps = {
  target: 'File'
}, _temp4), (_applyDecoratedDescriptor(_class10.prototype, 'loadScheduler', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'loadScheduler'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'sendMessageScheduled', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'sendMessageScheduled'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'sendMessageNow', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'sendMessageNow'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'onTextAreaChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'onTextAreaChange'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'changeMessageType', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'changeMessageType'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'updateFileStats', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'updateFileStats'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'getTestFileStats', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'getTestFileStats'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'updateTestFileStats', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'updateTestFileStats'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'sendTestFile', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'sendTestFile'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'changeFile', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'changeFile'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'deleteFromSelected', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'deleteFromSelected'), _class10.prototype), _applyDecoratedDescriptor(_class10.prototype, 'handleTagsChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class10.prototype, 'handleTagsChange'), _class10.prototype)), _class10)) || _class9);
var Detail = exports.Detail = (_dec5 = (0, _reactRedux.connect)(function (state) {
  return {
    messagesScheduled: state.messagesScheduled
  };
}, { markAsRead: _unread.markAsRead, getFileReport: _messages.getFileReport, sendTransactionReportLogRequest: _reports.sendTransactionReportLogRequest }), _dec5(_class12 = (_class13 = function (_React$Component) {
  (0, _inherits3.default)(Detail, _React$Component);

  function Detail(props) {
    (0, _classCallCheck3.default)(this, Detail);

    var _this35 = (0, _possibleConstructorReturn3.default)(this, (Detail.__proto__ || (0, _getPrototypeOf2.default)(Detail)).call(this, props));

    var path = _this35.props.location.pathname;
    _this35.is_file = path.indexOf("file") !== -1;

    _this35.state = {
      snack: {
        message: "",
        status: "",
        show: false
      }
    };

    if (_this35.is_file) {
      _this35.detail = _this35.props.location.state.detail;
      _this35.rows_ok = _this35.detail.rows_ok || 0;
      _this35.monitoring_messages = _this35.detail.monitoring_messages || 0;
      _this35.from = (0, _moment2.default)(_this35.detail.created_on).valueOf();
      _this35.to = (0, _moment2.default)().valueOf();
      _this35.props.getFileReport(_this35.detail.file_uid, _this35.from, _this35.to);
    }
    return _this35;
  }

  (0, _createClass3.default)(Detail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var id = this.props.location.state.transaction_id;
      if (this.props.location.state.status === 'RECEIVED') {
        this.props.markAsRead([id]);
      }
    }
  }, {
    key: 'hideSnackBar',
    value: function hideSnackBar() {
      this.setState({ snack: (0, _extends3.default)({}, this.state.snack, { show: false }) });
    }
  }, {
    key: 'onRequestLog',
    value: function onRequestLog() {
      var _this36 = this;

      var filters = {
        file_uid: this.detail.file_uid
      };
      this.props.sendTransactionReportLogRequest(this.from, filters).then(function () {
        return _this36.setState({ snack: { message: (0, _translations2.default)("REPORT REQUESTED"), status: "success", show: true }
        });
      }).catch(function () {
        return _this36.setState({ snack: { message: (0, _translations2.default)("REPORT REQUEST ERROR"), status: "error", show: true }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.Detail, (0, _extends3.default)({}, this.props, {
        onRequestLog: this.onRequestLog,
        snack: this.state.snack,
        isFile: this.is_file,
        rows_ok: this.rows_ok,
        hideSnackBar: this.hideSnackBar,
        monitoring_messages: this.monitoring_messages
      }));
    }
  }]);
  return Detail;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class13.prototype, 'hideSnackBar', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class13.prototype, 'hideSnackBar'), _class13.prototype), _applyDecoratedDescriptor(_class13.prototype, 'onRequestLog', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class13.prototype, 'onRequestLog'), _class13.prototype)), _class13)) || _class12);
var ErrorDetail = exports.ErrorDetail = (_dec6 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.messagesSent.data,
    isLoading: state.messagesSent.loading
  };
}, {
  get: _messages.getErrors
}), _dec6(_class14 = function (_React$Component2) {
  (0, _inherits3.default)(ErrorDetail, _React$Component2);

  function ErrorDetail() {
    (0, _classCallCheck3.default)(this, ErrorDetail);
    return (0, _possibleConstructorReturn3.default)(this, (ErrorDetail.__proto__ || (0, _getPrototypeOf2.default)(ErrorDetail)).apply(this, arguments));
  }

  (0, _createClass3.default)(ErrorDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this38 = this;

      if (__CLIENT__) {
        setTimeout(function () {
          _this38.props.get(_this38.props.params.transactionid);
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.isLoading) {
        return _react2.default.createElement(_components.Loading, null);
      }

      var item = this.props.data;
      var list = item.error_detail;
      var title = (0, _translations2.default)('ERROR DETAIL');
      var subtitle = (0, _moment2.default)(item.datetime).format('YYYY-MM-DD HH:mm');
      var content = item.content;
      var destination = function destination(item) {
        return item.tag ? item.tag.split(',') : [item.channel_type == 'HTML' ? item.msisdn || (0, _translations2.default)('UNKNOWN NUMBER') : item.destination_identifier];
      };

      var details = [[(0, _translations2.default)('SENT ON'), (0, _moment2.default)(item.datetime).format('YYYY-MM-DD HH:mm')], [(0, _translations2.default)('CREATED BY'), item.created_by], [(0, _translations2.default)('DESTINATION'), destination(item)], [(0, _translations2.default)('SENT MESSAGES'), item.total_credits - item.error_count], [(0, _translations2.default)('ERROR MESSAGES'), item.error_count]];

      if ((0, _sessionPermissions.sessionPermissions)('transactions:error:view')) {
        details.push([(0, _translations2.default)('ERROR DETAIL'), (0, _translations2.default)('CLICK HERE TO VIEW ERROR DETAIL'), !item.error_count, {
          pathname: '/messages/detail/' + item._id,
          state: {
            modal: true,
            returnTo: '/messages',
            modalSize: { width: '830px', height: '400px' }
          }
        }]);
      }

      return _react2.default.createElement(
        'div',
        { className: _Message5.default.errordetail },
        _react2.default.createElement(
          'div',
          { className: _Message5.default.bar },
          _react2.default.createElement(
            'div',
            { className: _Message5.default.icon },
            _react2.default.createElement(md.error, { size: 20, color: '#FFF' })
          ),
          _react2.default.createElement(
            'div',
            { className: _Message5.default.title },
            _react2.default.createElement(
              'h1',
              null,
              title
            ),
            _react2.default.createElement(
              'h2',
              null,
              subtitle
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _Message5.default.content },
          content
        ),
        _react2.default.createElement(
          'table',
          { className: _Message5.default.table },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                (0, _translations2.default)('MESSAGE ERROR CODE')
              ),
              _react2.default.createElement(
                'th',
                null,
                (0, _translations2.default)('MESSAGE ERROR COUNT')
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            item.source == 'CSMS' ? list.map(function (d) {
              return _react2.default.createElement(
                'tr',
                { key: 'errors_' + d.error_code },
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { title: d.event_status + ': ' + d.error_message },
                    d.error_code
                  )
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  d.error_count
                )
              );
            }) : _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { title: item.event_status + ': ' + item.delivery_status },
                  item.delivery_status
                )
              ),
              _react2.default.createElement(
                'td',
                null,
                item.error_count
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { colSpan: '2' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    className: _Message5.default.link,
                    to: {
                      pathname: '/messages/detail',
                      state: {
                        modal: true,
                        returnTo: '/messages',
                        modalSize: { width: '830px', height: '400px' },
                        detail: {
                          title: (0, _translations2.default)('MESSAGE DETAIL'),
                          subtitle: (0, _translations2.default)('SENT ON') + ' ' + (0, _moment2.default)(item.datetime).format('DD/MM'),
                          content: item.content,
                          Icon: md.message,
                          count: item.event_count,
                          values: details
                        }
                      }
                    }
                  },
                  (0, _translations2.default)('RETURN TO MESSAGE DETAIL')
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ErrorDetail;
}(_react2.default.Component)) || _class14);